/**
 * 旧版数据 handsontable
 */
const WEATHER_HT_COLUMNS = [
    {
        data: 'time',
        key: 'time',
        title: '日期',
        type: 'text',
        readOnly: true,
    },
    {
        data: 't10m',
        key: 't10m',
        title: '环境温度（℃）',
        type: 'numeric',
    },
    {
        data: 'lwgab_swgdn',
        key: 'lwgab_swgdn',
        title: '太阳辐射强度（W/m2）',
        type: 'numeric',
    },
    {
        data: 'tsoil3',
        key: 'tsoil3',
        title: '土壤平均温度（℃）',
        type: 'numeric',
    },
    {
        data: 'u10m',
        key: 'u10m',
        title: '距地面10m处东向风速（m/s）',
        type: 'numeric',
    },
    {
        data: 'u50m',
        key: 'u50m',
        title: '距地面50m处东向风速（m/s）',
        type: 'numeric',
    },
    {
        data: 'v10m',
        key: 'v10m',
        title: '距地面10m处北向风速（m/s）',
        type: 'numeric',
    },
    {
        data: 'v50m',
        key: 'v50m',
        title: '距地面50m处北向风速（m/s）',
        type: 'numeric',
    },
];
/**
 * 旧版数据
 */
const WEATHER_COLUMNS = [
    {
        dataIndex: 'time',
        key: 'time',
        title: '日期',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 't10m',
        key: 't10m',
        title: '环境温度（℃）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'lwgab_swgdn',
        key: 'lwgab_swgdn',
        title: '太阳辐射强度（W/m2）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'tsoil3',
        key: 'tsoil3',
        title: '土壤平均温度（℃）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'u10m',
        key: 'u10m',
        title: '距地面10m处东向风速（m/s）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'u50m',
        key: 'u50m',
        title: '距地面50m处东向风速（m/s）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'v10m',
        key: 'v10m',
        title: '距地面10m处北向风速（m/s）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'v50m',
        key: 'v50m',
        title: '距地面50m处北向风速（m/s）',
        width: 150,
        align: 'center',
    },
];

/**
 * 新版天气数据
 */
const WEATHER_COLUMNS_New = [
    {
        dataIndex: 'time',
        key: 'time',
        title: '日期',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 't10m',
        key: 't10m',
        title: '环境温度（℃）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'tsoil3',
        key: 'tsoil3',
        title: '土壤平均温度（℃）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'u10m',
        key: 'u10m',
        title: '距地面10m处东向风速（m/s）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'u50m',
        key: 'u50m',
        title: '距地面50m处东向风速（m/s）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'v10m',
        key: 'v10m',
        title: '距地面10m处北向风速（m/s）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'v50m',
        key: 'v50m',
        title: '距地面50m处北向风速（m/s）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'adj_sfc_sw_direct_all_1h',
        key: 'adj_sfc_sw_direct_all_1h',
        title: '短波直射强度（W/m²）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'adj_sfc_sw_diff_all_1h',
        key: 'adj_sfc_sw_diff_all_1h',
        title: '短波散射强度（W/m²）',
        width: 150,
        align: 'center',
    },
    {
        dataIndex: 'solar_zen_angle_1h',
        key: 'solar_zen_angle_1h',
        title: '太阳天顶角°',
        width: 150,
        align: 'center',
    },
];

/**
 * 新版天气数据 handsontable
 */
const WEATHER_HT_COLUMNS_New = [
    {
        data: 'time',
        key: 'time',
        title: '日期',
        type: 'text',
        readOnly: true,
    },
    {
        data: 't10m',
        key: 't10m',
        title: '环境温度（℃）',
        type: 'numeric',
    },
    {
        data: 'tsoil3',
        key: 'tsoil3',
        title: '土壤平均温度（℃）',
        type: 'numeric',
    },
    {
        data: 'u10m',
        key: 'u10m',
        title: '距地面10m处东向风速（m/s）',
        type: 'numeric',
    },
    {
        data: 'u50m',
        key: 'u50m',
        title: '距地面50m处东向风速（m/s）',
        type: 'numeric',
    },
    {
        data: 'v10m',
        key: 'v10m',
        title: '距地面10m处北向风速（m/s）',
        type: 'numeric',
    },
    {
        data: 'v50m',
        key: 'v50m',
        title: '距地面50m处北向风速（m/s）',
        type: 'numeric',
    },
    {
        data: 'adj_sfc_sw_direct_all_1h',
        key: 'adj_sfc_sw_direct_all_1h',
        title: '短波直射强度（W/m²）',
        type: 'numeric',
    },
    {
        data: 'adj_sfc_sw_diff_all_1h',
        key: 'adj_sfc_sw_diff_all_1h',
        title: '短波散射强度（W/m²）',
        type: 'numeric',
    },
    {
        data: 'solar_zen_angle_1h',
        key: 'solar_zen_angle_1h',
        title: '太阳天顶角°',
        type: 'numeric',
    },
];
export { WEATHER_HT_COLUMNS, WEATHER_COLUMNS, WEATHER_COLUMNS_New, WEATHER_HT_COLUMNS_New };
